export const GAME_EVENTS = {
    "GAME_ADD_RESULT": "GAME_ADD_RESULT",
    "GAME_ADD_FAIL_RESULT": "GAME_ADD_FAIL_RESULT",
    "GAME_ADD_SUCCESS": "GAME_ADD_SUCCESS",
    "GAME_START_ROUND": "GAME_START_ROUND",
    "GAME_END_ROUND": "GAME_END_ROUND",
    "GAME_END_ROUND_RECALCED": "GAME_END_ROUND_RECALCED",
    "GAME_SPIN_START": "GAME_SPIN_START",
    "GAME_SPIN_END": "GAME_SPIN_END",
    "GAME_ENTER_FREESPINS": "GAME_ENTER_FREESPINS",
    "GAME_FREESPIN_END": "GAME_FREESPIN_END",
    "GAME_BIGWIN": "GAME_BIGWIN",
    "GAME_END_ROUND_FREESPINS": "GAME_END_ROUND_FREESPINS",
    "GAME_SKIP_ROUND_ID": "GAME_SKIP_ROUND_ID",
    "GAME_NEW_FREESPINS": "GAME_NEW_FREESPINS",
    "GAME_ALLOW_FREESPINS": "GAME_ALLOW_FREESPINS",
    "GAME_INVALID_FREESPINS": "GAME_INVALID_FREESPINS",
    "REQUEST_PAUSE_GAME":"REQUEST_PAUSE_GAME",
    "GAME_PAUSED":"GAME_PAUSED",
    "GAME_AUTOSTART_START":"GAME_AUTOSTART_START",
    "GAME_AUTOSTART_STOP":"GAME_AUTOSTART_STOP",
};